import React from 'react';

import { TableCell } from '@material-ui/core';

import Input from '../../../../components/Input';

export interface IEditableTableCell {
  editMode: boolean;
  label: string;
  noIcon?: boolean;
  onChange: any;
  placeholder?: string;
  inputAdornment?: JSX.Element;
  valuePrefix?: string;
  type: 'number' | 'text';
  value: string | number | undefined | null;
}

export const EditableTableCell = ({
  editMode,
  label,
  noIcon,
  onChange,
  placeholder,
  inputAdornment,
  valuePrefix,
  type,
  value
}: IEditableTableCell): JSX.Element => (
  <TableCell>
    {editMode ? (
      <Input
        type={type}
        label={label}
        value={value === null ? undefined : value}
        onChange={onChange}
        placeholder={placeholder}
        fullWidth={true}
        startAdornment={inputAdornment}
        noIcon={noIcon}
      />
    ) : (
      <span>
        {value && valuePrefix}
        {value}
      </span>
    )}
  </TableCell>
);
